import React from 'react';
import { Telephone, Envelope } from 'react-bootstrap-icons';
import '../../views/EjecutivoView.css';

const Intendente = ({ ejecutivo }) => {
  return (
    <>
      {ejecutivo != null && (
        <div className="ejecutivo-box">
          <div className="ejecutivo-nombre">Intendente</div>
          <div className="ejecutivo-sub">{ejecutivo.intendenteNombre}</div>
          <div className="ejecutivo-sub">
            <Envelope />{' '}
            <a className="ejecutivo-link" href={'mailto:' + ejecutivo.intendenteEmail}>
              {ejecutivo.intendenteEmail}
            </a>
          </div>
          <div className="ejecutivo-sub">
            <Telephone /> Teléfono {ejecutivo.intendenteTelefono}
          </div>
        </div>
      )}
    </>
  );
};

export default React.memo(Intendente);
